import CameraIconPath from "@ingka/ssr-icon/paths/camera";

export default CameraIconPath;
